<template>
  <div class="afterType">
    <div class="list">
      <ul>
        <li>
          <div class="product">
            <div v-if="list.list && list.list.length == 1" class="productBox">
              <img v-lazy="list.list[0].img_path" />
              <div class="proContent" v-if="list.list[0] && list.list[0].name">
                <b>
                  {{
                    list.list[0].name.length > 23
                      ? list.list[0].name.slice(0, 24) + '...'
                      : list.list[0].name
                  }}
                </b>
                <p>
                  <b>{{ list.list[0].spec }}</b>
                </p>
              </div>
            </div>
            <div
              v-if="list.list && list.list.length > 1"
              class="productBox bestSellingSwiper"
              style="overflow: hidden; position: relative"
            >
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item, idx) in list.list" :key="idx">
                  <img v-lazy="item.img_path" />
                  <img v-if="item.isgift == 1" class="zeng" src="../../assets/images/zeng1.png" />
                  <img
                    class="zeng"
                    src="../../assets/images/stock.png"
                    v-if="item.isprogift == 1"
                  />
                </swiper-slide>
              </swiper>
            </div>
            <span
              class="totelPrice"
              :style="list.list && list.list.length == 1 ? { position: 'static' } : {}"
              v-if="list.list"
            >
              <span class="price">
                {{
                  parseFloat(list.totalmoney || 0)
                    .toFixed(2)
                    .slice(
                      0,
                      parseFloat(list.totalmoney || 0)
                        .toFixed(2)
                        .indexOf('.')
                    )
                }}
                <i>
                  {{
                    parseFloat(list.totalmoney || 0)
                      .toFixed(2)
                      .slice(
                        parseFloat(list.totalmoney || 0)
                          .toFixed(2)
                          .indexOf('.'),
                        parseFloat(list.totalmoney || 0).toFixed(2).length
                      )
                  }}
                </i>
              </span>
              <b>共{{ list.total || 0 }}件</b>
            </span>
          </div>
          <div class="proFooter" @click="keFu">
            <p>
              <img src="../../assets/images/kefu.png" />
              联系客服
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="type">
      <ul>
        <li
          @click="salRetClick(list.isrefund_money, 'refund')"
          :style="list.isrefund_money == 0 ? { opacity: 0.21 } : { opacity: 1 }"
        >
          <div class="title">
            <img src="../../assets/images/refund.png" />
            <p>仅退款</p>
          </div>
          <div class="content">
            <b>无需退回商品</b>
            <img src="../../assets/images/jt3.png" />
          </div>
        </li>
        <li
          @click="salRetClick(list.isrefund_item_money, 'refundSales')"
          :style="list.isrefund_item_money == 0 ? { opacity: 0.21 } : { opacity: 1 }"
        >
          <div class="title">
            <img src="../../assets/images/sales.png" />
            <p>退货退款</p>
          </div>
          <div class="content">
            <b>已确认收货，需退回商品</b>
            <img src="../../assets/images/jt3.png" />
          </div>
        </li>
      </ul>
    </div>
    <footer>
      <p>退款说明</p>
      <span>
        1.使用现金券支付的订单，退款时按照订单剩余商品是否满足现金券使用规则计算，退还的现金券沿用原始属性。
        <br />
        2.使用金币抵扣的订单，退款同时退还金币。
        <br />
        3.特价商品(活动中说明)，非质量问题不支持退换货。
      </span>
    </footer>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, kefu, fenxiang, basepath } from '../../assets/common/js/config'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'afterType',
  data() {
    return {
      afterSalesType: String(this.$route.query.type)
        ? this.$route.query.type
        : -1 /**0 单个申请 2 整单申请 */,
      id: this.$route.query.oid ? this.$route.query.oid : '',
      ordersheet_id: this.$route.query.id ? this.$route.query.id : '',
      nums: this.$route.query.nums ? this.$route.query.nums : '',
      allrefund: this.$route.query.allrefund ? this.$route.query.allrefund : 0,
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      value: 0,
      maxVal: '',
      list: []
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'aftertype' })
    }
    this.getData()
  },
  methods: {
    getData: function () {
      var url =
        this.$ajax.applyBatchRefund_URL +
        '?orderid=' +
        this.id +
        '&ordersheet_id=' +
        this.ordersheet_id +
        '&nums=' +
        this.nums +
        (this.allrefund ? '&allrefund=' + this.allrefund : '')
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data
        }
      })
    },
    salRetClick: function (isrefund, type) {
      var ordersheetArr = [],
        numArr = []
      sessionStorage.setItem('refundSales_data', JSON.stringify(this.list.list))
      if (sessionStorage.getItem('refundSales_data')) {
        let refundSales_data = JSON.parse(sessionStorage.getItem('refundSales_data'))
        refundSales_data.map((item) => {
          ordersheetArr.push(item.ordersheet_id)
          numArr.push(item.num)
        })
      }
      var url = this.$ajax.checkDrawOrderRefund_URL,
        data = {
          orderid: this.list.orderid,
          ordersheet_id: ordersheetArr.join(),
          num: numArr.join()
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (res.data.ispop == 1) {
            this.$dialog
              .confirm({
                message: res.data.msg,
                className: 'collect_button_alert',
                cancelButtonColor: '#FC0324',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '确定'
              })
              .then(function () {
                submitafter()
              })
              .catch(function () {
                sessionStorage.removeItem('refundSales_data')
              })
          } else {
            submitafter()
          }
        } else {
          sessionStorage.removeItem('refundSales_data')
        }
      })
      var submitafter = () => {
        if (isrefund == 1 && type == 'refund') {
          this.$router.replace({
            path: '/refundsales',
            query: {
              type: this.afterSalesType,
              returnType: type,
              id: this.list.orderid,
              ...(this.allrefund ? { allrefund: this.allrefund } : {})
            }
          })
        } else if (isrefund == 1 && type == 'refundSales') {
          this.$router.replace({
            path: '/refundsales',
            query: {
              type: this.afterSalesType,
              returnType: type,
              id: this.list.orderid,
              ...(this.allrefund ? { allrefund: this.allrefund } : {})
            }
          })
        }
      }
    },
    keFu: function () {
      var goodslist = [],
        goodsnum = 0
      this.list.map((item) => {
        goodslist.push({
          name: item.name,
          pictureUrl: encodeURIComponent(item.img_path)
        })
        goodsnum += parseInt(item.num)
      })
      var k =
        'order_status=0&status_custom=' +
        this.list.orderstatus_text +
        '&create_time=' +
        new Date(this.list.ordertime.replace(/-/g, '/')).getTime() +
        '&order_code=' +
        this.list.no +
        '&order_url=' +
        encodeURIComponent(basepath + 'orderdetails?id=' + this.list.orderid) +
        '&goods_count=' +
        goodsnum +
        '&total_fee=' +
        parseInt(parseFloat(this.list.pay_money) * 100) +
        '&goods=' +
        JSON.stringify(goodslist)
      kefu(1, k)
    }
  }
}
</script>

<style scoped lang="scss">
.list ul li p,
.list ul li .proFooter,
.product,
.type ul li {
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
.afterType {
  .list {
    > ul {
      margin-bottom: 0.11rem;
      > li {
        background: #fff;
        margin: 0.11rem 0.11rem 0;
        padding: 0.15rem 0.15rem 0;
        > p {
          border-bottom: 1px solid #efefef;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size: 0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
              }
            }
          }
          i {
            font-style: normal;
            color: #292929;
            font-size: 0.12rem;
            display: flex;
            display: -o-flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -moz-flex;
            align-items: center;
            -o-align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -moz-align-items: center;
            b {
              border-left: 1px solid #d8d8d8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              img {
                width: 0.12rem;
                height: 0.12rem;
              }
            }
          }
        }
        .product {
          position: relative;
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            img {
              width: 0.8rem;
              height: 0.8rem;
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              > b {
                font-size: 0.13rem;
                font-weight: 400;
                color: rgba(41, 41, 41, 1);
                line-height: 0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              > p {
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                > b {
                  font-size: 0.11rem;
                  font-weight: 400;
                  color: rgba(108, 108, 108, 1);
                  line-height: 0.16rem;
                  display: block;
                }
              }
              .choicesNum {
                height: 0.22rem;
                margin-top: 0.11rem;
              }
            }
          }
          .totelPrice {
            position: absolute;
            right: 0;
            z-index: 10;
            opacity: 0.85;
            height: 0.8rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight: 600;
              color: #222222;
              line-height: 0.14rem;
              &:before {
                content: '￥';
                font-size: 0.1rem;
                font-weight: 600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            > b {
              color: #908d8d;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight: 400;
              text-align: center;
            }
          }
          .bestSellingSwiper {
            .swiper-container {
              padding-right: 0.6rem;
            }
            .swiper-wrapper {
              .swiper-slide {
                width: 0.8rem;
                height: 0.8rem;
                position: relative;
                background-color: white;
                img {
                  width: 100%;
                  height: 100%;
                  &.zeng {
                    position: absolute;
                    right: -0.01rem;
                    top: -0.01rem;
                    width: 0.28rem;
                    height: 0.28rem;
                  }
                  &.add {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 0.36rem;
                    height: 0.36rem;
                  }
                  &.both {
                    width: 0.26rem;
                    height: 0.13rem;
                  }
                }
              }
            }
            & + .totelPrice {
              background: rgba(255, 255, 255, 1);
              box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            }
          }
        }
        .proFooter {
          margin-top: 0.2rem;
          border-top: 1px solid rgba(216, 216, 216, 1);
          justify-content: center;
          height: 0.37rem;
          > p {
            font-size: 0.12rem;
            font-weight: 400;
            color: #363636;
            line-height: 0.17rem;
            padding: 0.1rem auto;
            img {
              width: 0.15rem;
              height: 0.15rem;
              margin-right: 0.04rem;
            }
          }
        }
      }
    }
  }
  .recommend {
    background: #fff;
    margin: 0.1rem 0.11rem;
    padding: 0.2rem 0.11rem;
    border-radius: 0.03rem;
    > p {
      font-size: 0.13rem;
      color: #000000;
      padding-bottom: 0.1rem;
      border-bottom: 0.01rem solid #d8d8d8;
    }
    > span {
      margin-top: 0.09rem;
      margin-bottom: 0.03rem;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -o-justify-content: space-between;
      -ms-justify-content: space-between;
      i {
        display: block;
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 0.17rem;
        font-style: normal;
      }
    }
    ul {
      li {
        display: flex;
        display: -ms-flex;
        display: -o-flex;
        display: -moz-flex;
        display: -webkit-flex;
        padding-bottom: 0.11rem;
        &:last-of-type {
          padding-bottom: 0;
        }
        .check {
          width: 0.31rem;
          input {
            top: 0.35rem;
          }
          label {
            position: relative;
            width: 100%;
            height: 100%;
            i {
              position: absolute;
              top: 0.35rem;
            }
          }
        }
        img {
          width: 0.8rem;
          height: 0.8rem;
        }
        .content {
          margin-left: 0.07rem;
          padding-top: 0.08rem;
          flex: 1;
          -o-flex: 1;
          -moz-flex: 1;
          -ms-flex: 1;
          -webkit-flex: 1;
          > p {
            font-size: 0.13rem;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);
            line-height: 0.18rem;
            b {
              float: right;
              font-size: 0.1rem;
              font-weight: 400;
              color: rgba(144, 141, 141, 1);
              line-height: 0.14rem;
            }
          }
          > b {
            display: block;
            font-size: 0.11rem;
            font-weight: 400;
            color: rgba(108, 108, 108, 1);
            line-height: 0.16rem;
            margin: 0.05rem 0 0.16rem;
          }
          span {
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -o-flex;
            display: -ms-flex;
            justify-content: space-between;
            -webkit-justify-content: space-between;
            -moz-justify-content: space-between;
            -o-justify-content: space-between;
            -ms-justify-content: space-between;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -o-align-items: center;
            -ms-align-items: center;
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight: 600;
              color: #222222;
              line-height: 0.14rem;
              &:before {
                content: '￥';
                font-size: 0.1rem;
                font-weight: 600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
          }
        }
      }
    }
  }
  .type {
    ul {
      background: #fff;
      margin: 0.1rem 0.11rem 0;
      padding: 0 0.15rem;
      border-radius: 0.03rem;
      li {
        height: 0.7rem;
        border-bottom: 1px solid #d8d8d8;
        &:last-of-type {
          border-bottom: 1px solid transparent;
        }
        .title {
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          display: -o-flex;
          align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          -o-align-items: center;
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
          p {
            font-size: 0.15rem;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 0.21rem;
            margin-left: 0.1rem;
          }
        }
        .content {
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          display: -o-flex;
          align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          -o-align-items: center;
          b {
            display: block;
            font-size: 0.11rem;
            font-weight: 400;
            color: rgba(176, 176, 176, 1);
            line-height: 0.16rem;
            margin-right: 0.06rem;
          }
          img {
            width: 0.1rem;
            height: 0.1rem;
            padding: 0.01rem 0.02rem;
          }
        }
      }
    }
  }
  footer {
    margin: 0.15rem;
    p {
      margin-top: 0.15rem;
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 0.18rem;
    }
    span {
      display: block;
      margin-top: 0.1rem;
      font-size: 0.11rem;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 0.16rem;
    }
  }
}
.check {
  font-weight: 400;
  position: relative;
  i {
    display: block;
    width: 0.16rem;
    height: 0.16rem;
    float: left;
    margin-right: 0.08rem;
    background: url(../../assets/images/uncheck.png) no-repeat left top;
    background-size: 100% 100%;
  }
  input {
    display: block;
    float: left;
    position: absolute;
    width: 0.16rem;
    height: 0.16rem;
    left: 0;
    top: 0.54rem;
    outline: none;
    -webkit-appearance: none;
    opacity: 0;
  }
  .on {
    background: url(../../assets/images/check.png) no-repeat left top;
    background-size: 100% 100%;
  }
  label {
    float: left;
    font-size: 0.12rem;
    color: #444;
  }
}
</style>
<style>
.van-stepper__minus,
.van-stepper__plus,
.van-stepper__input {
  height: 0.22rem !important;
  margin: 0 0 !important;
}
.van-stepper__minus {
  border-radius: 0.13rem 0 0 0.13rem !important;
  border: 1px solid #e5e5e5 !important;
  border-right: none !important;
  background: none !important;
}
.van-stepper__plus {
  border-radius: 0 0.13rem 0.13rem 0 !important;
  border: 1px solid #e5e5e5 !important;
  border-left: none !important;
  background: none !important;
}
.van-stepper__minus::before,
.van-stepper__plus::before {
  width: 0.09rem !important;
  height: 0.03rem !important;
}
.van-stepper__minus::after,
.van-stepper__plus::after {
  width: 0.03rem !important;
  height: 0.09rem !important;
}
.van-stepper__input {
  background: #eeeff4 !important;
  border: 1px solid #eeeff4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/after/afterType.vue